import React, { FC } from 'react';
import { List as ChakraList } from '@chakra-ui/react';

interface IconListProps {
  color?: string;
  children?: React.ReactNode;
  textStyle?: string;
  spacing?: string;
}

export const IconList: FC<IconListProps> = ({ color, children, textStyle = 'p2', spacing }) => {
  return (
    <ChakraList.Root className="fa-ul" data-testid="core-icon-list" color={color} textStyle={textStyle} gap={spacing}>
      {children}
    </ChakraList.Root>
  );
};
